// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"705":"5eddac81","936":"a35bbf37","944":"26dbdb6f"}[chunkId] + ".chunk.js";
};